// @USAGE
// const dispatch = useDispatch();
// const temporary_reducer = useSelector(state => state.temporary_reducer);
// > set: dispatch(temporary_actions.{function});
// > get: temporary_reducer.{key_name_of_state}

import {createSlice} from "@reduxjs/toolkit";

const init_state = {
    // 앱이 다시 켜지는 순간 초기화 (AppContent 참고)
};

const temporary_slice = createSlice({
    name: "temporary",
    initialState: init_state,
    reducers: {
        setValue(state, {payload}) {
            state[payload.key] = payload.value;
        },
        clear(state) {
            // call when application start up -> reset variables
            return (state = init_state);
        },
    },
});

export const temporary_actions = temporary_slice.actions;
export default temporary_slice.reducer;
